<template>
  <div style="padding-top: -2px; margin-top: -2px">
    <s-select-generic
      ref="sgeneric"
      autocomplete
      full
      :config="config"
      :disabled="disabled"
      :readonly="readonly"
      itemvalue="GenID"
      id="GenID"
      itemtext="GenDescription"
      :clearable="clearable"
      @add="addEvent()"
      :no-default="noDefault"
      :value="value"
      @input="input($event)"
      :returnObject="returnObject"
      :label="label"
    />
  </div>
</template>

<script>
import _sGenericService from "../../services/General/GenericService";

export default {
  components: {},
  props: {
    id: {
      type: String,
      default: "GenID",
    },
    value: null,
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    noDefault: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    typeArea: {
      type: String,
      default: "0",
    },
    typeCultive: {
      type: String | Number,
      default: "0",
    },
  },
  data: () => ({
    valueRadio: null,
    selected: [],

    dialogAdd: false,
    item: 0,
    items: [],
    config: {},
  }),

  watch: {
    value() {
      // console.log("Campaign value:", this.value);
    },
    typeCultive(newVal, oldVal) {
      // console.log("typeCultive changed from", oldVal, "to", newVal);
      this.updateConfig();
      // Refrescar el select después de actualizar config
      this.$nextTick(() => {
        if (this.$refs.sgeneric) {
          this.$refs.sgeneric.load();
        }
      });
    },
    typeArea(newVal) {
      // console.log("typeArea changed to", newVal);
      this.updateConfig();
    },
  },
  methods: {
    input(item) {
      this.$emit("input", item);
    },
    updateConfig() {
      // console.log("📝 Updating config with:", {
      //   typeArea: this.typeArea,
      //   typeCultive: this.typeCultive
      // });
      this.config = {
        url: _sGenericService.getUrlSearchCampaignArea(),
        title: this.label,
        params: {
          requestID: this.$fun.getUserID(),
          typeArea: this.typeArea,
          typeCultive: this.typeCultive ? parseInt(this.typeCultive) : 0,
        },
      };
    },
  },
  created() {
    // this.config.title = this.label;
    // this.config.params.requestID = this.$fun.getUserID();

    this.updateConfig();
  },
  mounted() {
    // console.log("valuesds", this.value);
  },
};
</script>
